import * as React from "react";
import { useNavigate } from "react-router-dom";
import { NGButton } from "../../newcomponents/button/Button";

const LandingRaw: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="onboard-landing-page flex flex-col items-center">
      <div className="my-8 text-xl font-bold">Welcome to Control Plane</div>
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="text-center">Start Using Control Plane by Creating an Account</div>
        <NGButton variant="action" onClick={() => navigate("/billing/account/-createfirst")}>
          Create Account
        </NGButton>
      </div>
    </div>
  );
};

export const Landing = LandingRaw;
